import { Module, MutationTree, ActionTree, GetterTree, ModuleTree } from 'vuex'

interface Toast {
  show: boolean
  type: 'success' | 'error' | 'warning' | 'info'
  title: string
  message: string
}

interface UIState {
  loading: boolean
  loadingMessage: string
  toast: Toast
}

const state: UIState = {
  loading: false,
  loadingMessage: 'Loading...',
  toast: {
    show: false,
    type: 'success',
    title: '',
    message: ''
  }
}

const getters: GetterTree<UIState, any> = {
  isLoading: (state) => state.loading,
  loadingMessage: (state) => state.loadingMessage,
  toastState: (state) => state.toast
}

const mutations: MutationTree<UIState> = {
  SET_LOADING: (state, loading: boolean) => {
    state.loading = loading
  },
  SET_LOADING_MESSAGE: (state, message: string) => {
    state.loadingMessage = message
  },
  SHOW_TOAST: (state, payload: { type: string; title: string; message: string }) => {
    state.toast = {
      show: true,
      type: payload.type as Toast['type'],
      title: payload.title,
      message: payload.message
    }
  },
  HIDE_TOAST: (state) => {
    state.toast.show = false
  },
  RESET_TOAST: (state) => {
    state.toast = {
      show: false,
      type: 'success',
      title: '',
      message: ''
    }
  }
}

const actions: ActionTree<UIState, any> = {
  showLoading ({ commit }, message = 'Loading...') {
    commit('SET_LOADING_MESSAGE', message)
    commit('SET_LOADING', true)
  },
  hideLoading ({ commit }) {
    commit('SET_LOADING', false)
  },
  showToast ({ commit }, payload: { type: string; title: string; message: string; duration?: number }) {
    const { duration = 5000 } = payload
    commit('SHOW_TOAST', payload)
    if (duration > 0) {
      setTimeout(() => {
        commit('HIDE_TOAST')
      }, duration)
    }
  },
  hideToast ({ commit }) {
    commit('HIDE_TOAST')
  }
}

const uiModule: Module<UIState, any> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default uiModule
